import React from "react";
import { Box, Paper } from "@mui/material";
import ContentShell from "components/ContentShell";
import EncryptionUtilityPanel from "components/EncryptionUtilityPanel";

const EncryptionUtility = () => (
  <ContentShell title="Encryption Utility">
    <Box sx={{ p: 3, maxWidth: 800, mx: "auto" }}>
      <Paper sx={{ p: 4, borderRadius: 2 }}>
        <EncryptionUtilityPanel />
      </Paper>
    </Box>
  </ContentShell>
);

export default EncryptionUtility;
